// import {toJS} from 'mobx'
import generify from './generic'

export const points = generify('experiences-service', 'points', 'point')

points.getFromExperience = (experienceUid, showDeleted) => {
  return points.getFrom('experiences', experienceUid, showDeleted)
}
